@let _label = label();
@let _jsonLdFaqs = jsonLdFaqs();

<span [wcCxJsonLd]="snippetImages()"></span>

@if (!!_jsonLdFaqs){
  <span [wcCxJsonLd]="_jsonLdFaqs"></span>
}

@if (!!_jsonLdFaqs) {
  <span [wcCxJsonLd]="_jsonLdFaqs"></span>
}

<div class="service-page-template">
  @if (_label !== 'CONTACT') {

    <cx-page-slot position="Navigation" />

    <div class="service-page-content">
      @switch (true) {
        @case (_label === 'FORFAIT') {
          <sd-border-wrapper [hasBorder]="false">
            <cx-page-slot position="DynamicBody" class="is-forfait" />
            <sd-tab-group>
              <sd-tab>
                <ng-container sd-tab-title>
                  <span>{{ 'faq.withTransport' | translate }}</span>
                </ng-container>
                <div sd-tab-pane>
                  <cx-page-slot position="FaqWithTransport" />
                </div>
              </sd-tab>
              <sd-tab>
                <ng-container sd-tab-title>
                  <span>{{ 'faq.withoutTransport' | translate }}</span>
                </ng-container>
                <div sd-tab-pane>
                  <cx-page-slot position="FaqWithoutTransport" />
                </div>
              </sd-tab>
            </sd-tab-group>
          </sd-border-wrapper>
        }
        @case (_label === 'FAQ' || _label === 'IFU') {
          <wc-sis-categories />
        }
        @default {
          <sd-border-wrapper [hasBorder]="false">
            <cx-page-slot position="DynamicBody" />
          </sd-border-wrapper>
          @if (_label === 'REPAIR') {
            <wc-store-locator
              [isRepair]="true"
              [hideCardActions]="true"
              [hideChooseButton]="true"
              [posTypes]="['ASP_SERVICE_CENTER']"
              [posFeatures]="[]"
            />
          }
        }
      }
    </div>

  } @else {

    <iframe
      wcIframeResizer
      id="iframeContactForm"
      [src]="iframeUrl()"
      width="100%"
      title="Contact"
      autoresize="true"
    ></iframe>

  }
</div>

<cx-page-slot position="SEO" />
